<div class="cs-card">
    <!-- Banner -->
    <div class="cs-card__banner" [style.background-color]="bannerBgColor">
        <!-- Placeholder: "More coming soon" with centered icon -->
        <ng-container *ngIf="isPlaceholder">
            <div class="cs-card__placeholder">
                <div class="cs-card__grid-bg">
                    <div class="cs-card__grid-cell" *ngFor="let i of [1,2,3,4,5,6,7,8,9]"></div>
                </div>
                <div class="cs-card__icon-badge">
                    <span class="ham-icon cs-card__fork-icon">
                        <i class="code-fork-outline"></i>
                    </span>
                </div>
            </div>
        </ng-container>

        <!-- Normal coming-soon logo -->
        <ng-container *ngIf="!isPlaceholder && logoSrc">
            <img [src]="logoSrc" [alt]="name" class="cs-card__logo" />
        </ng-container>
    </div>

    <!-- Body -->
    <div class="cs-card__body">
        <div class="cs-card__text">
            <p class="cs-card__name">{{ name }}</p>
            <p class="cs-card__desc">{{ description }}</p>
        </div>
        <button
            class="cs-card__btn"
            [class.cs-card__btn--filled]="isPlaceholder"
            [class.cs-card__btn--outline]="!isPlaceholder"
            (click)="requestClicked.emit()">
            {{ isPlaceholder ? ('aumico_companies_integrations_btn_submit_request' | i18next) : ('aumico_companies_integrations_btn_request' | i18next) }}
        </button>
    </div>
</div>
